/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Store the data sent to the analytics stack
 */
var AnalyticsTrackData = /** @class */ (function () {
    function AnalyticsTrackData(datas) {
        if (datas.size === 0) {
            throw new Error('You must at least provide one property');
        }
        this.datas = datas;
    }
    /**
     * Check if the current data match the analytics requirements
     * @param mandatoryProperties the properties that data must have
     */
    AnalyticsTrackData.prototype.isValid = function (mandatoryProperties) {
        var e_1, _a;
        var valid = true;
        try {
            for (var mandatoryProperties_1 = __values(mandatoryProperties), mandatoryProperties_1_1 = mandatoryProperties_1.next(); !mandatoryProperties_1_1.done; mandatoryProperties_1_1 = mandatoryProperties_1.next()) {
                var key = mandatoryProperties_1_1.value;
                valid = this.datas.has(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mandatoryProperties_1_1 && !mandatoryProperties_1_1.done && (_a = mandatoryProperties_1.return)) _a.call(mandatoryProperties_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return valid;
    };
    return AnalyticsTrackData;
}());
export default AnalyticsTrackData;
